<script>
    import { navigate }      from "svelte-routing"
    import pkg               from '../package.json'
    import { user, appdata } from './shared/stores.js'
    import * as api          from './shared/api.js'
    import Loader            from './shared/Loader.svelte'
    import WhenLoggedIn      from './WhenLoggedIn.svelte'
    import WhenLoggedOff     from './WhenLoggedOff.svelte'
    import Reply             from './pages/requests/Reply.svelte'

    console.log(`Dogma Console '[VI]{version} - {date}[/VI]' (${pkg.gitBranch} ${pkg.gitAbbrevHash})`)

    /* This allows unauthenticated users to reply to inquiries */
    const re    = /\/empresa\/(?<company>\d+)\/pedidos\/(?<domain>[A-Za-z0-9.]+)\/pedido\/(?<inquiry>\w+)\/enviar\/(?<place>\w+)/g
    const reply = re.exec(window.location.pathname)
    const fa    = reply && new URLSearchParams(window.location.search).has('fa') /* fa = force auth */

    let loading = $user.loggedIn ? true : false
    let error = false

    function loadAppDataError(err) {
        error = err
        $user.loggedIn = false
        setTimeout(() => { 
            loading = false
            error   = false
        }, 3000)
    }

    function onLogin(isLoggedIn) {
        if(isLoggedIn) {
            loadAppData().then(it => { $user.loggedIn = true }).catch(loadAppDataError)
        }
    }

    function onLogoff(isLoggedOff) {
        $user.loggedIn = !isLoggedOff
        navigate('/')
    }

    function onActivated(isActivated) {
        if(isActivated) {
            loadAppData().then(() => {
                $user.loggedIn = true
                navigate('/')
            })
        }
    }

    function loadAppData() {
        return api
            .get('/appdata')
            .then(api.toJsonIf200)
            .then(data => {
                $appdata = data
                loading = false
                return true
            })
    }

    if(loading) {
        new Promise((resolve, reject) => {
            setTimeout(() => { resolve() }, 1000)
        }).then(() => loadAppData().catch(loadAppDataError))
    }

</script>

{#if loading || error}
    <Loader what="Carregando" {error}/>
{:else if $user.loggedIn}
    <WhenLoggedIn {onLogoff}/>    
{:else if reply && !fa} <!-- This allows unauthenticated users to reply to inquiries -->
    <Reply  _company = {reply.groups.company} 
            _domain  = {reply.groups.domain}
            _inquiry = {reply.groups.inquiry}
            _source  = {reply.groups.place}/>
{:else}
    <WhenLoggedOff {onLogin} {onActivated} />
{/if}
